<template>
  <div>
    <v-container fill-height fluid>
    <v-row>
      <v-flex xs3 class="mr-2">
        <Search
          v-model="filters.search"
          :label="$t('SEARCH')"
          prepend-icon="search"
          :delay="500"
        />
      </v-flex>
      <v-flex xs3 class="mr-2">
        <Search
          v-model="filters.search_make"
          :label="$t('fields.editor')"
          prepend-icon="search"
          :delay="500"
        />
      </v-flex>
      <v-spacer></v-spacer>
    </v-row>
    </v-container>
    <v-data-table
      :headers="headers"
      :items="items"
      :server-items-length="totalItems"
      :no-data-text="$t('NO_DATA')"
      :no-results-text="$t('NO_DATA')"
      hide-default-footer
      :options.sync="pagination"
      :loading="loading"
      class="elevation-1"

    >

      <template v-slot:item.make="{ item }">
            {{ item.make }}
      </template>

      <template v-slot:item.name="{ item }">
            {{ item.name ? item.name.toUpperCase() : '' }}
      </template>

      <template v-slot:item.updated_at="{ item }">
            {{ item.created_at | timeFormat }}
      </template>

      <template v-slot:item.qty="{ item }">
            {{ item.pivot.qty }}
      </template>

      <template v-slot:item.warehouse_location="{ item }">
            {{ item.pivot.warehouse_location }}
      </template>

      <template v-slot:item.total_load="{ item }">
            {{ parseInt(item.total_load) || 0 }}
      </template>

      <template v-slot:item.total_unload="{ item }">
            {{ parseInt(item.total_unload) || 0 }}
      </template>

      <template v-slot:item.total_transfer="{ item }">
            {{ parseInt(item.total_transfer) || 0 }}
      </template>

      <template v-slot:item.total_transfer_in="{ item }">
            {{ parseInt(item.total_transfer_in) || 0 }}
      </template>


      <template v-slot:item.actions="{ item }">
        <v-flex>
          <v-btn
            icon
            color="blue"
            @click="showWarehouseProductLocationModal(item.pivot.warehouse_id, item.pivot.product_id)"
          >
            <v-icon>edit</v-icon>
          </v-btn>
        </v-flex>
      </template>

    </v-data-table>
    <div class="text-xs-center pt-2">
      <Paginator
        :total-items="totalItems"
        :page.sync="pagination.page"
        :items-per-page.sync="pagination.itemsPerPage"
        @change="fetchWarehouseProduct"
      />
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';

  import { warehousesService } from '../../../utils/services/warehouses.service';
  import Search from '../../shared/Inputs/Search.vue';
  import WarehouseProductLocationModal from '../../modals/Warehouses/WarehouseProductLocationModal.vue';
  import Paginator from '../../shared/Paginator';

  export default {
    name: 'WarehouseProductDetails',
    components: { Search, Paginator },
    props: {
      warehouse: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        loading: false,
        items: [],
        filters: {
          search: '',
          search_make: '',
        },
        totalItems: 0,
        pagination: {
          page: 1,
          itemsPerPage: 10,
          sortDesc: [false],
          sortBy: ['created_at'],
        },
        headers: [
          {
            text: this.$t('fields.id'),
            align: 'left',
            value: 'id',
          },
          { text: this.$t('fields.sku'), value: 'sku' },
          { text: this.$t('fields.editor'), value: 'make' },
          { text: this.$t('fields.name'), value: 'name' },
          { text: this.$t('fields.quantity'), value: 'qty' },
          { text: this.$t('fields.warehouse_location'), value: 'warehouse_location' },
          { text: this.$t('fields.tot_load'), value: 'total_load' },
          { text: this.$t('fields.tot_unload'), value: 'total_unload' },
          { text: this.$t('fields.tot_transfer'), value: 'total_transfer' },
          { text: this.$t('fields.tot_transfer_in'), value: 'total_transfer_in' },
          { text: this.$t('fields.created_at'), value: 'created_at' },
          { text: this.$t('fields.actions'), value: 'actions' },
        ],
      };
    },
    computed: {
      requestFilters() {
        const filters = {};
        if (this.pagination.sortBy.length === 1 && this.pagination.sortDesc.length === 1) {
          const { sortBy, sortDesc } = this.pagination;
          filters.sortBy = sortBy;
          filters.sortDesc = sortDesc;
        }
        filters.search = this.filters.search;
        filters.search_make = this.filters.search_make;
        return filters;
      },
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('modal', ['showModal', 'hideModal']),
      ...mapActions('alert', ['showToast']),

      async showWarehouseProductLocationModal(warehouseId, productId) {
        this.showModal({
          component: WarehouseProductLocationModal,
            data: {
              stored: {
                warehouse_id: warehouseId,
                product_id: productId,
              },
          },
          options: {
            title: this.$t('PRODUCT_WAREHOUSE_LOCATION'),
            onSave: (
              form,
              error,
            ) => warehousesService.updateProductLocation(warehouseId, productId, form)
            .then(() => {
              this.fetchWarehouseProduct(this.pagination.page);
              this.hideModal({});
              this.showToast({ type: 'success', message: this.$t('SAVED') });
            })
            .catch(error => {
              this.handleError(error, this.errors);
            })
            .finally(() => {
              this.fetchWarehouseProduct(this.pagination.page);
            }),
          },
        });
      },

      async fetchWarehouseProduct(forcePage) {
        this.loading = true;
        const { page, itemsPerPage } = this.pagination;
        return warehousesService.product(this.warehouse.id, {
          page: page || forcePage || 1,
          itemsPerPage,
          filters: this.requestFilters,
        })
        .then((response) => {
            this.items = response.data.data;
            this.totalItems = response.data.meta.total;
            this.pagination = this.getPagination(
              response.data.meta,
              { oldPagination: this.pagination, forcePage },
            );
        })
        .catch(error => {
          this.handleError(error, this.errors);
        })
        .finally(() => {
          this.loading = false;
        });
      },
    },
    async created() {
      await this.fetchWarehouseProduct(1);
    },

    watch: {
      filters: {
        deep: true,
        handler() {
          this.fetchWarehouseProduct(1);
        },
      },
      'pagination.sortBy': {
        handler(oldVal, newVal) {
          if (newVal !== oldVal) {
            this.fetchWarehouseProduct(1);
          }
        },
      },
    },
  };
</script>
